export enum AVO_EVENTS {
  VIEW_TRAVEL_HOME = 'VIEW_TRAVEL_HOME',
  VIEW_TRAVEL_PAGE = 'VIEW_TRAVEL_PAGE',
  VIEW_TRAVEL_SEARCH_SCREEN = 'VIEW_TRAVEL_SEARCH_SCREEN',
  SELECT_TRAVEL_SEARCH = 'SELECT_TRAVEL_SEARCH',
  VIEW_TRAVEL_RESULTS_SCREEN = 'VIEW_TRAVEL_RESULTS_SCREEN',
  PROCEED_TO_CHECKOUT = 'PROCEED_TO_CHECKOUT',
  VIEW_TRAVEL_RESERVATION_DETAIL = 'VIEW_TRAVEL_RESERVATION_DETAIL',
  TRAVEL_PACKAGE_VALIDATION_ERROR = 'TRAVEL_PACKAGE_VALIDATION_ERROR',
  SELECT_CANCELLATION_BANNER = 'SELECT_CANCELLATION_BANNER',
  VIEW_CANCELLATION_PAGE = 'VIEW_CANCELLATION_PAGE',
  SELECT_CANCELLATION_CONFIRM = 'SELECT_CANCELLATION_CONFIRM',
  TRAVEL_ORDER_CONFIRMED = 'TRAVEL_ORDER_CONFIRMED',
  TRAVEL_CHANGES_SEARCH_ERROR = 'TRAVEL_CHANGES_SEARCH_ERROR',
  TRAVEL_SEARCH_ERROR = 'TRAVEL_SEARCH_ERROR',
  TRAVEL_SEAMLESS_ERROR = 'TRAVEL_SEAMLESS_ERROR',
  SELECT_FLEXDATES = 'SELECT_FLEXDATES',
  VIEW_FLEXDATES = 'VIEW_FLEXDATES',
  SELECT_FLEXDATE_OPTION = 'SELECT_FLEXDATE_OPTION',
  SELECT_BANNER = 'SELECT_BANNER',
  VIEW_BOOKING_SCREEN = 'VIEW_BOOKING_SCREEN',
  TRAVEL_BOOKING_ERROR = 'TRAVEL_BOOKING_ERROR',
  VIEW_TRAVEL_ITEM_DETAIL = 'VIEW_TRAVEL_ITEM_DETAIL',
  TRAVEL_LOCATION_NOT_FOUND = 'TRAVEL_LOCATION_NOT_FOUND',
  CREATE_TRAVEL_ALERT = 'CREATE_TRAVEL_ALERT',
  SELECT_CHANGES_SEARCH = 'SELECT_CHANGES_SEARCH',
  SELECT_CHANGE_OPTION = 'SELECT_CHANGE_OPTION',
  VIEW_PAX_FORM = 'VIEW_PAX_FORM',
  VIEW_INVOICING_FORM = 'VIEW_INVOICING_FORM',
  VIEW_TRAVEL_CHANGES_RESULTS = 'VIEW_TRAVEL_CHANGES_RESULTS',
  SELECT_VIEW_SEATMAP = 'SELECT_VIEW_SEATMAP',
  VIEW_SEATMAP_ERROR = 'VIEW_SEATMAP_ERROR',
  VIEW_SEATMAP_FLIGHT = 'VIEW_SEATMAP_FLIGHT',
  SELECT_SEATMAP_SEAT = 'SELECT_SEATMAP_SEAT',
  SELECT_SEATMAP_SEAT_REMOVE = 'SELECT_SEATMAP_SEAT_REMOVE',
  SELECT_SEATMAP_CHANGE = 'SELECT_SEATMAP_CHANGE',
  VIEW_TRAVEL_ASSISTANCE_MODAL = 'VIEW_TRAVEL_ASSISTANCE_MODAL',
  TRAVEL_UPSELL_OPTIONS_ERROR = 'TRAVEL_UPSELL_OPTIONS_ERROR',
  SELECT_UPSELL_OPTIONS = 'SELECT_UPSELL_OPTIONS',
  SELECT_TRAVEL_ASSISTANCE = 'SELECT_TRAVEL_ASSISTANCE',
}
